module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "als"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("Also by Marie-Monique Robin")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("Voleurs d’organes: Enquête sur un trafic")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Les Cent Photos du siècle")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Le Sixième Sens: Science et paranormal (with Mario Varvoglis)")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Escadrons de la mort, l’école française")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("L’École du soupçon: Les dérives de la lutte contre la pédophilie")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608a5c5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mari_9781595585363_oeb_als_r1.vue
// module id = 63
// module chunks = 0